export default __webpack_public_path__ + "static/media/welcome-tour-3.92b5726d.png";